import React, { useState } from "react";
import { useDispatch } from "react-redux";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupportedOutlined";
import { Box } from "@mui/system";
import { deActiveDisruption } from "../../../store/actions/smrt/disruptionAction";
import { useTranslation } from "react-i18next";
import parser from "html-react-parser";

const DeactivateDisruption = ({ announcement }) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(deActiveDisruption(announcement));

    handleClose();
  };
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        startIcon={<BrowserNotSupportedIcon fontSize="small" />}
        sx={{ boxShadow: 3 }}
        color="error"
        variant="contained"
      >
        {t("link.deactivateBtn")}
      </Button>

      <Dialog maxWidth="sm" open={open} onClose={handleClose}>
        <Box component="form" onSubmit={handleSubmit}>
          <DialogTitle>{t("link.disruptConfirmTitle")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {parser(t("link.deactivateConfirmText"))}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} variant="outlined" fullWidth>
              {tCommon("cancelBtn")}
            </Button>
            <Button variant="contained" fullWidth type="submit">
              {t("link.deactivateConfirmBtn")}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default DeactivateDisruption;
